class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('submit', (event)=>{
      event.preventDefault();
      event.stopPropagation();
      this.onSubmitHandler(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // console.log('renderPage')
    const decodedSearchParams = decodeURIComponent(searchParams);
    const hasSizeFilter = decodedSearchParams.includes('filter.v.option.größe');
    // Force the availability filter
    const urlParams = new URLSearchParams(searchParams);
    if (hasSizeFilter) {
      if (!urlParams.has('filter.v.availability') || urlParams.get('filter.v.availability') !== '1') {
        urlParams.append('filter.v.availability', '1');

        const availabilityCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]');
        if (availabilityCheckbox) {
          availabilityCheckbox.checked = true;
        }
      }
      searchParams = urlParams.toString();
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // const loadingSpinners = document.querySelectorAll(
    //   '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    // );
    // loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // searchParams = new URLSearchParams(new FormData(facetForm))
   let  filteredsearchParams = FacetFiltersForm.checkSearchParams(urlParams);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${filteredsearchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static checkSearchParams(searchParams) {
    const params = [...searchParams.keys()].filter(key => key.includes('filter.v.') && !key.includes('filter.v.price') && !key.includes('filter.v.availability'));
    if(params.length > 0 && !searchParams.has('filter.v.availability')) {
      searchParams.append('filter.v.availability', 1);
    } else if(params.length === 0 && !window.location.href.includes('/search')) {
      searchParams.delete('filter.v.availability');
    }

    return searchParams;
  }

  static renderSectionFromFetch(url, event) {
    // console.log("renderSectionFromFetch", url);
    
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        document.dispatchEvent(new CustomEvent('facet-filters-form:rendered'));
        document.body.classList.remove('overflow-hidden-mobile');
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const ajaxinateContainer = document.getElementById('AjaxinateContainer');
    if (ajaxinateContainer) {
      ajaxinateContainer.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('AjaxinateContainer')?.innerHTML;

      ajaxinateContainer.querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
    }

    loadProducts();
    updateProductsGrid();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    // const loadingSpinners = document.querySelectorAll(
    //   '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    // );
    // loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Add a check to prevent duplicate filters
    const processedIds = new Set();

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => {
      const filterType = element.querySelector('.mobile-facets__title')?.textContent.trim();
      if (processedIds.has(filterType)) {
        return false;
      }
      processedIds.add(filterType);
      return !matchesId(element);
    });

    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const existingFilter = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
          if (existingFilter) {
            existingFilter.before(elementToRender);
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const usedFiltersCount = 10;
    const usedCustomSizeFiltersCount = 4;
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.results-counter', '.AjaxinatePaginationPrev', '.AjaxinatePaginationNext', '.filter-counter-price'];

    // Handle counters separately
    const counterSelectors = [
      ...Array.from({ length: usedFiltersCount }, (_, i) => `.filter-counter-${i + 1}`),
      ...Array.from({ length: usedCustomSizeFiltersCount }, (_, i) => `.filter-counter-size-${i + 1}`)
    ];

    // Update regular elements
    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);
      if (sourceElement && targetElement) {
        targetElement.innerHTML = sourceElement.innerHTML;
      }
    });

    // Update counters
    counterSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      if (sourceElement) {
        const targetElement = document.querySelector(selector) ||
          document.querySelector(`[data-counter="${selector}"]`);
        if (targetElement) {
          targetElement.innerHTML = sourceElement.innerHTML;
        }
      }
    });
  }

  static renderCounts(source, target) {
    // Update the counter in the title
    const titleElement = target.querySelector('.mobile-facets__title');
    const isCustomSizeFilter = target.getAttribute('data-index')?.includes('mobile-size-filter');

    if (isCustomSizeFilter) {
      const counterElement = titleElement?.querySelector('[class^="filter-counter-size-"]');
      const newCounterElement = source.querySelector('[class^="filter-counter-size-"]');

      if (titleElement && newCounterElement) {
        if (counterElement) {
          counterElement.innerHTML = newCounterElement.innerHTML;
        } else {
          titleElement.appendChild(newCounterElement.cloneNode(true));
        }
      }
    } else {
      const counterElement = titleElement?.querySelector('[class^="filter-counter-"]');
      const newCounterElement = source.querySelector('[class^="filter-counter-"]');

      if (titleElement && newCounterElement) {
        if (counterElement) {
          counterElement.innerHTML = newCounterElement.innerHTML;
        } else {
          titleElement.appendChild(newCounterElement.cloneNode(true));
        }
      }
    }

    // Update other elements
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');
    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');
    if (sourceWrapElement && targetWrapElement) {
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const isCustomSizeFilter = target.getAttribute('data-index')?.includes('mobile-size-filter');
    const sourceCount = isCustomSizeFilter
      ? source.querySelector('[class^="filter-counter-size-"]')?.innerHTML
      : source.querySelector('[class^="filter-counter-"]')?.innerHTML;

    if (sourceCount) {
      const targetElement = target.querySelector('.mobile-facets__title');
      const counterElement = isCustomSizeFilter
        ? targetElement.querySelector('[class^="filter-counter-size-"]')
        : targetElement.querySelector('[class^="filter-counter-"]');

      if (counterElement) {
        counterElement.innerHTML = sourceCount;
      } else {
        const span = document.createElement('span');
        span.className = isCustomSizeFilter ? `filter-counter-size-${target.dataset.index.split('-').pop()}` : 'filter-counter';
        span.innerHTML = sourceCount;
        targetElement.appendChild(span);
      }
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('AjaxinateContainer')?.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    // console.log('onSubmitHandler')
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
